export default "__VITE_ASSET__pMjLljAF__"